export const INSPECTION_CAPTURE = 'inspectionCapture';
export const INSPECTION_CREATE = 'inspectionCreate';
export const INSPECTION_VEHICLE_UPDATE = 'InspectionVehicleUpdate';
export const INSPECTION_LIST = 'inspectionList';
export const INSPECTION_PROMPT = 'inspectionPrompt';
export const LANDING = 'landing';
